import styled, { css } from 'styled-components';

export const ContentSection = styled.section`
  ${({
    theme, $direction, $align, $justify, $minWidth, $flex,
  }) => css`
    display: flex;
    flex-direction: ${$direction};
    align-items: ${$align};
    justify-content: ${$justify};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.white.primary};
    min-width: ${$minWidth || 'auto'};
    flex: ${$flex || 1};
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      min-width: 100%;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin: 0;
  width: 100%;
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 24px;
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;
